import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { addToCart, removeFromCart } from '../slices/cartSlice';

const AddToCart = ({ product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { cartItems } = useSelector((state) => state.cart);

    const qty = useMemo(() => {
    const item = cartItems.find(
      (ci) =>
        ci._id === product._id &&
        ci.selectedPriceCustomization === 0 &&
        ci.selectedSpiceLevel === 'Regular' &&
        ci.selectedSweetness === 'Regular'
    );
    return item ? item.quantity : 0;
  }, [cartItems, product._id]);

  const [pillState, setPillState] = useState(null); // 'adding' | 'removing'
  const [pillText, setPillText] = useState('');

  const dispatchAdd = (quantity) => {
    dispatch(
      addToCart({
        ...product,
        quantity,
        selectedPriceCustomization: 0,
        selectedSpiceLevel: 'Regular',
        selectedSweetness: 'Regular',
      })
    );
  };

  const handleIncrement = () => {
    if (qty >= 10) return;

    dispatchAdd(qty + 1);

    setPillState('adding');
    setPillText('Added');

    setTimeout(() => {
      setPillState(null);
      setPillText('');
    }, 500);
  };

  const handleDecrement = () => {
    if (qty === 0) return;

    if (qty === 1) {
      dispatch(
        removeFromCart({
          _id: product._id,
          selectedPriceCustomization: 0,
          subCategory: product.subCategory,
          selectedSpiceLevel: 'Regular',
          selectedSweetness: 'Regular',
        })
      );

      setPillState('removing');
      setPillText('Removed');

      setTimeout(() => {
        setPillState(null);
        setPillText('');
      }, 500);

      return;
    }

    dispatchAdd(qty - 1);

    setPillState('removing');
    setPillText('Removed');

    setTimeout(() => {
      setPillState(null);
      setPillText('');
    }, 500);
  };

  return (
    <div className="mt-2 text-center">
      {/* Quantity Pill */}
      <div className={`qty-pill mx-auto mb-2 ${pillState}`}>
        <div className="qty-fill" />

        <button
          type="button"
          className="qty-btn"
          onClick={handleDecrement}
          disabled={qty === 0}
        >
          −
        </button>

        <span className="qty-value">
          {pillText || qty}
        </span>

        <button
          type="button"
          className="qty-btn"
          onClick={handleIncrement}
          disabled={qty>=10}
        >
          +
        </button>
      </div>

      {/* Customize Button */}
      <Button
        variant="primary"
        size="sm"
        className="w-100 text-nowrap"
        onClick={() => navigate(`/product/${product._id}`)}
      >
        Customize
      </Button>
    </div>
  );
};

export default AddToCart;